import React, { Component } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';

export default class ReportShipment extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.shipmentsList.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>Invoice</th>
                <th className="hidden-md-down">CustomerName</th>
                <th className="hidden-xs-down">TransactionDate</th>
                <th className="hidden-md-down" title="QuickBooksMapping identifier">ItemNumber</th>
                <th title="Item name - brand - grade">Item</th>
                <th className="hidden-xs-down">Qty</th>
                <th className="hidden-xs-down">Price</th>
                <th className="hidden-md-down">InventoryQty</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.props.shipmentsList.map((s,idx) => {
                return (
                  <tr key={idx}>
                    <td>{s.invoice}</td>
                    <td className="hidden-md-down">{s.customer_name}</td>
                    <td className="hidden-xs-down">{moment(s.transaction_date, 'MM/DD/YYYY hh:mm').format('MM/DD/YYYY hh:mm')}</td>
                    <td className="hidden-md-down">{s.item_number}</td>
                    <td>{s.item}</td>
                    <td className="hidden-xs-down">{ parseFloat(s.quantity.toFixed(2)) }</td>
                    <td className="hidden-xs-down">{ parseFloat(s.price.toFixed(2)) }</td>
                    <td className="hidden-md-down">{ parseFloat(s.inventory_quantity.toFixed(2)) }</td>
                    <td>
                      { s.inventory_quantity > 0 ?
                        <NavLink className="btn-sm btn-info" to={`/shipment/${s.invoice}/`}>
                            <i className="fa fa-eye"></i>
                        </NavLink>
                      :
                        <NavLink className="btn-sm btn-info" to={`/return/${s.invoice}/`}>
                            <i className="fa fa-eye"></i>
                        </NavLink>
                      }
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
